import mainOidc from '@/auth';

let routes = [
  {
    path: 'order',
    component: () => import('@/components/common/RooshRouterView'),
    children: [
      {
        path: '',
        name: 'order.index',
        component: () => import('@/views/Order/Index'),
      },
      {
        path: ':id/detail',
        name: 'order.detail',
        component: () => import('@/views/Order/Detail'),
      },
    ],
    meta: {
      authName: mainOidc.authName
    },
  },
];

export default routes;
